export default __webpack_public_path__ + "static/media/profile-img.63517683.PNG";